import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/**
 * AdminListItem — unified list item for all admin list/detail panels.
 *
 * Props:
 *   title       (string)       — primary text
 *   image       (string|null)  — URL for thumbnail image (e.g. quest icon)
 *   avatar      (string|null)  — single character shown in a circle (e.g. user initial)
 *   subtitle    (string|null)  — secondary text line (description preview)
 *   badges      (ReactNode[])  — array of badge elements (QuestLabel, etc.) shown after title
 *   meta        (array)        — footer row items: [{ icon, text }]
 *   selected    (boolean)      — whether this item is currently selected
 *   onClick     (function)     — click handler
 *   className   (string)       — additional class name
 */
export default function AdminListItem({
  title,
  image,
  avatar,
  subtitle,
  badges,
  meta,
  selected = false,
  onClick,
  className = ''
}) {
  return (
    <div
      className={`admin-list-item ${selected ? 'selected' : ''} ${className}`}
      onClick={onClick}
    >
      <div className="admin-list-item-header">
        <div className="admin-list-item-title-row">
          {image && (
            <div className="admin-list-item-image">
              <img src={image} alt="" />
            </div>
          )}
          {avatar && !image && (
            <div className="admin-list-item-avatar">
              {avatar}
            </div>
          )}
          <h4 className="admin-list-item-title">{title}</h4>
        </div>
        {badges && badges.length > 0 && (
          <div className="admin-list-item-badges">
            {badges}
          </div>
        )}
      </div>

      {subtitle && (
        <p className="admin-list-item-subtitle">{subtitle}</p>
      )}

      {meta && meta.length > 0 && (
        <div className="admin-list-item-meta">
          {meta.map((item, i) => (
            <span key={i} className="admin-list-item-meta-tag">
              {item.icon && <FontAwesomeIcon icon={item.icon} />}
              {item.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
